/* eslint-disable no-use-before-define */
import React from 'react'
import {arrayFrom, cleanObject, show, getId} from '../twd'

export default ({Last, invType, sort, rows, selection, onSelect}) => {

    let isNone = invType==='-'
    let isMuni = invType==='M'
    let isCorp = invType==='C'
    let isCd = invType==='S'
    let isTreasury = invType==='T'
    let isAgency = invType==='A'
    let showRating = !isNone && !isCd && !isTreasury
    let showMarket = !isNone && (isMuni || isCorp || isAgency)
    return <thead>
        <tr>
        <th className="text-body" style={{width:'25px', maxWidth:'25px'}}>
            <SelectAll rows={rows} selection={selection} onSelect={onSelect} />
        </th>
        <th className="text-body text-right">Qty</th>
        <th className="text-body text-right">Min</th>
        <th className="text-body text-right">Incr</th>
        {isMuni && <th className="text-body">State</th>}
        <th className="text-body"style={{maxWidth:'250px'}}><SortLink Last={Last} sort={sort} field='holdIssue'>Issuer</SortLink></th>
        {isCd && <th className="text-body">FDIC #</th>}
        <th className="text-body text-right"><SortLink Last={Last} sort={sort} field='holdCoupon'>Coupon</SortLink></th>
        {isCd && <th className="text-body">Coupon frequency</th>}
        {isCd && <th className="text-body">Coupon type</th>}
        <th className="text-body text-right"><SortLink Last={Last} sort={sort} field='holdMaturitySortDt'>Maturity</SortLink></th>
        <th className="text-body text-right"><SortLink Last={Last} sort={sort} field='askPrice'>Price</SortLink></th>
        <th className="text-body text-center">Book</th>
        <th className="text-body text-right"><SortLink Last={Last} sort={sort} field='askYieldmat'>YTM</SortLink></th>
        <th className="text-body text-right"><SortLink Last={Last} sort={sort} field='askYield'>YTW</SortLink></th>
        {showRating && <th className="text-body" colSpan="2" style={{whiteSpace:'nowrap'}}>Moody's / S&amp;P</th>}
        {showMarket && <th className="text-body">Market check</th>}
        <th className="text-body text-center" style={{maxWidth:'55px'}}>&nbsp;</th>
        </tr>
    </thead>
}

const SelectAll = ({rows, selection, onSelect}) => {
    let id = getId()
    let n = arrayFrom(selection).length
    let isAll = n>0 && n >= arrayFrom(rows).length

    return <div className="checkbox" style={{margin:0}}>
    <input
        data-name="offerings-header-select-all"

        type="checkbox"
        id={id}
        checked={isAll}
        onChange={() => setTimeout(onSelect(!isAll)) }
    />
    <label htmlFor={id}></label>
    </div>

}

const SortLink = ({Last, field, sort, children}) => {
    let {field:sortField, direction:sortDirection} = (sort || {field:'holdMaturitySortDt', direction:'ASC'})
    let isSorted = field===sortField
    let isAsc = sortDirection==='ASC'
    return <React.Fragment>
    <button
        data-name="offerings-header-sort"
        data-field={field}
        data-direction={isSorted && isAsc ? 'DESC' : 'ASC'}

        className="btn-link text-body"
        style={{cursor:'pointer', color:'#767676', whiteSpace:'nowrap' }}
        onClick={() => {
            let direction = isSorted && isAsc ? 'DESC' : 'ASC'
            onSortChange(Last, {field, direction})
        }}
    >
    {children}
    {isSorted && (
        sortDirection==='ASC'
        ? <i className="material-icons">arrow_drop_up</i>
        : <i className="material-icons">arrow_drop_down</i>)}

    </button>
    </React.Fragment>
}


const onSortChange = (Last, {field, direction}) => {

    const ps = {...(Last.clone().params || {})}
    ps.sort = [{field, direction}]
    show('offerings', Object.assign({
        searchParams: cleanObject(ps),
        _ts: Date.now(),
        from: Last.value.from
    }))
}



// WEBPACK FOOTER //
// ./src/offerings/grid-header.js